// Tours quoted on WhatsApp (no payment on the site): price unit, booking panel and the quote dialog.
export default {
  quote: {
    title: 'Demandez un devis',
    unit: { boat: 'pour le bateau entier', schooner: 'pour la goélette entière', group: 'pour le groupe' },
    calendarPrice: { boat: '{{price}} pour le bateau entier', schooner: '{{price}} pour la goélette entière', group: '{{price}} pour le groupe' },
    priceLine: { boat: 'Bateau entier', schooner: 'Goélette entière', group: 'Groupe privé' },
    peopleTitle: 'Combien de personnes',
    people: 'Personnes',
    peopleHint: 'Tous ceux qui viennent',
    estimate: 'Prix de référence',
    badge: 'Devis sur WhatsApp',
    note: 'Aucun paiement sur le site : choisissez la date et le nombre de personnes, et notre équipe vous répond sur WhatsApp si c’est disponible.',
    ask: 'Demander un devis sur WhatsApp',
    askShort: 'Demander un devis',
    secure: 'Aucun paiement sur le site : notre équipe répond à votre devis sur WhatsApp.',
    count_one: '{{count}} personne',
    count_other: '{{count}} personnes',
    adults_one: '{{count}} adulte',
    adults_other: '{{count}} adultes',
    children_one: '{{count}} enfant',
    children_other: '{{count}} enfants',
    babies_one: '{{count}} bébé',
    babies_other: '{{count}} bébés',
    modal: {
      title: 'Demander un devis',
      lead: 'Écrivez votre nom : WhatsApp s’ouvre avec la demande prête, il suffit de l’envoyer.',
      tour: 'Sortie',
      date: 'Date',
      people: 'Personnes',
      name: 'Nom complet',
      namePlaceholder: 'Prénom et nom',
      nameError: 'Écrivez votre nom complet.',
      send: 'Envoyer sur WhatsApp',
      hint: 'Notre équipe vous répond sur WhatsApp si la date est disponible.',
      close: 'Fermer',
      sentTitle: 'Demande prête sur WhatsApp',
      sentText: 'Envoyez le message sur WhatsApp. Notre équipe vous répond si la date est disponible.',
      again: 'Rouvrir WhatsApp',
      done: 'Terminé',
    },
  },
};
